<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div class="row">
            <div class="col-12 col-md-6 col-lg-6">
                <div class="h2 mb-3"> <span>{{ $t('general.abono', {abono: textoAbono}) }}</span></div>
                <div>
                    <ul class="user-info info-list list-unstyled">
                        <li><label>{{ $t('renovar_abono.n_abonado_antiguo', {abonado: teatro.texto_abonado}) }}:</label> {{ data.partnerInfo.NumeroAnterior }}</li>
                        <li><label>{{ $t('renovar_abono.n_abonado_nuevo', {abonado: teatro.texto_abonado}) }}:</label> {{ data.partnerInfo.Numero }}</li>
                        <li><label>{{ $t('formularios.nombre') }}:</label> {{ data.personaInfo.Nombre }} {{ data.personaInfo.Apellido1 }} {{ data.personaInfo.Apellido2 }}</li>
                        <li><label>{{ $t('formularios.nacimiento') }}:</label> {{ data.personaInfo.FechaNacimiento }}</li>
                        <li><label>{{ $t('formularios.dni') }}:</label> {{ data.personaInfo.DNI }}</li>
                        <li><label>{{ $t('formularios.email') }}:</label> {{ data.personaInfo.Email }}</li>
                    </ul>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6">
                <div class="h2 mb-3"> <span>{{ $t('general.butaca') }}</span></div>
                <div>
                    <ul class="user-info info-list list-unstyled">
                        <li><label>{{ $t('general.sector') }}:</label> {{ data.titulo.NombreZona }}</li>
                        <li><label>{{ $t('general.fila') }}:</label> {{ data.titulo.Fila }}</li>
                        <li><label>{{ $t('general.butaca') }}:</label> {{ data.titulo.Asiento }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    export default {
        props: {
            data: {
                required: true,
                type: Object
            }
        },
        data() {
            return {
                generos: [
                    { name: 'Mujer', value: 'M' },
                    { name: 'Hombre', value: 'H' },
                    { name: 'Otro', value: 'O' }
                ]
            }
        },
        created() {
            this.generos.forEach(element => {
                element.value == this.data.Sexo ? this.data.Sexo = element : null;
            });
        },
        computed: {
            teatro(){
                return this.$store.getters.getTeatro
            },
            textoAbono() {
                const value = this.teatro && this.teatro.texto_abono;
                if (!value || typeof value !== 'string') return value;
                return value.charAt(0).toUpperCase() + value.slice(1);
            }
        }
    }
</script>